import * as ng from 'angular';
import { PanelHeaderData } from '../../../atomic-components/molecules/panels/panel-header/panel-header';
import { DisableFilter } from '../../../atomic-components/organisms/overview/overview';

export class TemplateDatabaseJobOverviewController {
    public static $inject: string[] = ['$translate'];

    public pageHeaderData: PanelHeaderData;
    public bundle;
    public overviewServiceData;
    public expertView: boolean;
    public disableFilter: DisableFilter;
    public overviewModel;

    private simpleFilter;
    private extendedFilters;
    private overviewUiSettings;

    constructor(private $translate: ng.translate.ITranslateService) {}

    public $onInit() {
        this.expertView = true;  // only expertview on job overviews
        this.disableFilter = {
            fancyFilter: false,
            searchFilter: false
        };

        if (this.bundle === undefined) {
            this.bundle = null;
        }
        const bundle = this.bundle || null;
        this.pageHeaderData = {
            backwardLink: bundle !== null
                ? 'bundle.id.dashboard'
                : 'database.dashboard',
            backwardText: bundle !== null
                ? this.$translate.instant('TR_090119-a32485_TR')
                : this.$translate.instant('TR_100119-ab6cc1_TR'),
            panelHeaderRoute: '',
            panelHeaderRouteParams: this.bundle !== null
                ? {bundleId: this.bundle.id}
                : null,
            panelIcon: 'database',
            panelTitle: this.$translate.instant('TR_160119-bbc9b6_TR')
        };
        this.overviewServiceData = {
            extendedFilters: this.extendedFilters,
            fancyFilterExpand: this.expertView,
            overviewService: 'databaseJob',
            overviewUiSettings: this.overviewUiSettings,
            simpleFilter: this.simpleFilter,
            sort: {
                field: 'jobAddDate',
                order: 'DESC'
            }
        };
    }
}

export class TemplateDatabaseJobOverviewComponent implements ng.IComponentOptions {
    public bindings = {
        bundle: '<',
        extendedFilters: '<',
        overviewModel: '<',
        overviewUiSettings: '<',
        simpleFilter: '<'
    };
    public controller = TemplateDatabaseJobOverviewController;
    public controllerAs = 'TemplateDatabaseJobOverviewCtrl';
    public template = require('./database-job-overview-template.html');
}
